<template>
<div class="form-group mt-3">
  <div class="form-inline">
    <label class="sr-only" for="start">Start</label>
    <input type="text" class="form-control mr-sm-2" v-model="block.start" placeholder="From 00:00:00:00">
    <label class="sr-only" for="end">End</label>
    <input type="text" class="form-control mr-sm-2" v-model="block.end" placeholder="To 00:00:00:00">
    <button type="button" class="btn btn-primary ml-2" @click="$emit('add', block)">{{ __('button.add') }}</button>
  </div>
</div>
</template>

<script>
export default {
  name: "BlockForm",
  data() {
    return {
      block: {
        start: '',
        end: ''
      }
    }
  }
}
</script>
